import { Grid, Typography, Box, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { getFeeds } from '../../Utils/apiService';
import { AuthContext } from '../../Helpers/Contexts/authContext';
interface MediaItem {
  url: string;
  type: string;
}
interface FeedItem {
  userImage: string;
  title: string;
  date: string;
  mediaLogo: string;
  content: string;
  hashtags: string;
  media: MediaItem[];
}

// Utility function to linkify URLs in text
function linkify(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1976d2;text-decoration:underline;">${url}</a>`;
  });
}

const Feed = () => {
  const { state: { user } } = useContext(AuthContext);
  const userData = user as any;
  const [feedData, setFeedData] = useState<FeedItem[]>([]);
  const isMobile = useMediaQuery('(max-width:900px)');
  useEffect(() => {
    getFeeds().then((res) => {
      const apiData = res?.data?.x || [];
      console.log(apiData, "apiDataapiDataapiDataapiData");

      const formattedData = apiData.map((item: any) => {
        const date = new Date(item.created_at.split(" ")[0]);
        const formattedDate = date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        }).replace(/ /g, ' ');
        const hashtags = (item.text.match(/#[\w]+/g) || []).join(' ');
        return {
          userImage: item?.user?.pfp_url ? item?.user?.pfp_url : "https://images.crunchbase.com/image/upload/c_pad,h_256,w_256,f_auto,q_auto:eco,dpr_1/kbstmn3zvcx9xiutzxso",
          title: item?.user?.username ? item?.user?.username : "-",
          date: `${formattedDate}`,
          mediaLogo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRj-X06O3ppyMhQotOP_Km27fpwe0FgZGqXiA&s",
          content: item.text,
          hashtags: hashtags,
          media: item.media ? item.media.map((m: any) => ({
            url: m.url,
            type: m.type, // photo, video, animated_gif
          })) : [],
        };
      });

      setFeedData(formattedData);
    });
  }, []);

  return (
    <Grid container spacing={2} sx={{ pt: 2, backgroundColor: "white", height: "84vh", margin: "1px", borderRadius: "10px", width: "100% !important" }}>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: 500, textAlign: "left" }}>Feed</Typography>
      </Grid>

      <Grid item xs={12} sx={{ height: "80vh", overflowY: "auto", px: 2 }}>
        {/* Spotlight section */}
        <Box sx={{ border: "1px solid #E6E6E8", borderRadius: "10px", fontSize: 14, mb: 2, background: "linear-gradient(90deg,#00387A,#006BB7)", p: 2 }}>
          <Typography sx={{ fontWeight: 400, color: "white", textAlign: "left" }}>In the spotlight</Typography>
          <Box sx={{ mt: 2 }}>
            <iframe
              width="100%"
              height="220"
              src="https://www.youtube.com/embed/SqXPk7gn5Qc?si=K1_Xum1hxvCJcmgw"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              style={{ borderRadius: "10px" }}
            ></iframe>
          </Box>
          <Typography sx={{ fontWeight: 400, color: "white", mt: 2, textAlign: "left" }}>Ruby House - Trifecta</Typography>
          <Typography sx={{ color: "white", textAlign: "left" }}>
            Ruby House has achieved an incredible milestone by winning the sports competition for the third consecutive year,
            showcasing their unparalleled talent, teamwork, and dedication.
          </Typography>
        </Box>

        {/* Feed items */}
        {feedData.map((item, index) => (
          <Box
            key={index}
            sx={{
              border: "1px solid #E6E6E8",
              borderRadius: "10px",
              mb: 2, fontSize: 14,
              backgroundColor: "white",
              p: 2,
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={1.5}>
                <img src={item.userImage} alt="User" style={{ width: isMobile ? "30px" : "50px", height: isMobile ? "30px" : "50px", borderRadius: "50%" }} />
              </Grid>
              <Grid item xs={9} style={{ textAlign: "left" }}>
                <Typography sx={{ fontWeight: 500 }}>{item.title}</Typography>
                <Typography sx={{ fontSize: 12, color: "gray" }}>{item.date}</Typography>
              </Grid>
              <Grid item xs={1.5}>
                <img src={item.mediaLogo} alt="Media" style={{ width: isMobile ? "30px" : "50px", height: isMobile ? "30px" : "50px", borderRadius: "50%" }} />
              </Grid>
            </Grid>
            <Typography
              mt={3}
              component="div"
              dangerouslySetInnerHTML={{ __html: linkify(item.content) }}
            />
            {item.hashtags && (
              <Typography mt={2} color="primary.main" fontSize={14}>
                {item.hashtags}
              </Typography>
            )}
            {/* Media section */}
            {item.media.length > 0 && (
              <Box mt={2} sx={{ display: 'flex', overflowX: 'auto', gap: 2 }}>
                {item.media.map((mediaItem, idx) => (
                  <Box key={idx} sx={{ minWidth: "100%", borderRadius: "10px", overflow: "hidden" }}>
                    {mediaItem.type === "photo" && (
                      <img
                        src={mediaItem.url}
                        alt={`media-${idx}`}
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                    )}

                    {mediaItem.type === "video" && (
                      <video
                        src={mediaItem.url}
                        autoPlay
                        controls
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                    )}

                    {mediaItem.type === "animated_gif" && (
                      <video
                        src={mediaItem.url}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default Feed;
